import produce from 'immer';

import PrimusHandler from 'api/primusHandler';
import {
  AUTH_INITIALIZE,
  AUTH_INITIALIZE_DONE,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_TWO_FACTOR,
  AUTH_CLEAR_DATA,
  AUTH_CLEAR_ERROR,
  AUTH_TWO_FACTOR_TIMEOUT,
} from '../constants';
import { Images } from 'util/images';

const initialState = {
  isInitialized: false,
  authTwoFactor: false,
  authLoading: false,
  authError: '',
  user: {},
  token: undefined,
  isTicketAuth: undefined,
  userRole: undefined,
  userId: undefined,
  isCommunityUser: false,
  company: undefined,
  department: undefined,
};

export default function auth(baseState = initialState, action) {
  return produce(baseState, (state) => {
    switch (action.type) {
      case AUTH_INITIALIZE:
        state.authLoading = true;
        break;
      case AUTH_INITIALIZE_DONE:
        state.isInitialized = true;
        state.authLoading = false;
        break;
      case AUTH_LOGIN_REQUEST:
        // reset values
        state.user = {};
        state.token = undefined;
        state.isTicketAuth = undefined;
        state.userRole = undefined;
        state.userId = undefined;
        state.isCommunityUser = false;
        state.company = undefined;
        state.department = undefined;
        // set new value
        state.authLoading = true;
        state.authError = '';
        break;
      case AUTH_LOGIN_SUCCESS:
        state.authLoading = false;
        state.authTwoFactor = false;
        let response = action?.response;
        state.user = response?.user;
        if (response?.user) {
          state.token = response.user.token || response.user.session;
          state.isTicketAuth = !!response.user.isTicketAuth || !!response.user.ticketSignIn;
          state.userRole = response.user.role;
          state.userId = response.user._id;
          state.isCommunityUser = !state.isTicketAuth && !!response.user.membershipAgreementAgreed;
          if (!state.user.avatar || state.user.avatar === '/images/placeholder-avatar.png') {
            state.user.avatar = Images.defaultAvatar;
          }
        }
        state.company = response?.company;
        state.department = response?.department;
        // REST sign in success, sign in with primus as well
        PrimusHandler.sendRequest({ isReact: true, _handler: 'sign-in' });
        break;
      case AUTH_LOGIN_FAILURE:
        state.authLoading = false;
        state.authError = action.error;
        break;
      case AUTH_TWO_FACTOR:
        state.authTwoFactor = true;
        break;
      case AUTH_TWO_FACTOR_TIMEOUT:
        state.authLoading = false;
        state.authTwoFactor = false;
        state.authError = action.error;
        break;
      case AUTH_CLEAR_DATA:
        state.authTwoFactor = false;
        state.authLoading = false;
        state.authError = '';
        state.user = {};
        state.token = undefined;
        state.isTicketAuth = undefined;
        state.userRole = undefined;
        state.userId = undefined;
        state.isCommunityUser = false;
        state.company = undefined;
        state.department = undefined;
        break;
      case AUTH_CLEAR_ERROR:
        state.authError = '';
        break;
      default:
        break;
    }
  });
}
